import { render, staticRenderFns } from "./ListarParticipantesEscolasDialog.vue?vue&type=template&id=49cb30da&scoped=true"
import script from "./ListarParticipantesEscolasDialog.vue?vue&type=script&lang=js"
export * from "./ListarParticipantesEscolasDialog.vue?vue&type=script&lang=js"
import style0 from "./ListarParticipantesEscolasDialog.vue?vue&type=style&index=0&id=49cb30da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49cb30da",
  null
  
)

export default component.exports